import { useTranslation } from "react-i18next";

function PlaceholderPage({ titleKey, titleFallback }) {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "fa";
  const title = titleKey ? t(titleKey) : titleFallback || "";
  const message = isRTL
    ? `وارد صفحه ${title} شدید`
    : `You have entered the ${title} page`;

  return (
    <div className={`panel2-placeholder-page ${isRTL ? "font_farsi" : "font_en"}`}>
      <h1 className="panel2-placeholder-title">{message}</h1>
    </div>
  );
}

export default PlaceholderPage;
